export default function SelectChart(){
    return <>

    </>
}